import React from "react"
import Layout from "../components/layout"
import VideoLightbox from "../components/video-lightbox"
import "../css/about.css"
import thumbnail from "../images/about-thumbnail.png"
import aboutVideo from "../videos/circ-about-us.mp4"
import SEO from "../components/seo"
// autoplay="autoplay"

const dates = [
  {
    date: 2019,
    tagline: "AWARD-WINNING",
    copy: "Project Ares, Circadence’s cyber learning platform, wins two key industry awards: SC Media’s “Best IT Security-Related Training Program” and Cyber Defense Magazine’s “Editor’s Choice, Cybersecurity Training."
  },
  {
    date: 2018,
    tagline: "PARTNERSHIP",
    copy: "Circadence announced a strategic partnership to host <a target='__blank' href='https://www.circadence.com/blog/living-our-mission-project-ares-takes-full-flight-with-cloud-native-architecture/'> Project Ares on the Microsoft Azure cloud </a> which established a cyber range learning environment that can scale to replicate networks, complex enterprises, interconnected city infrastructure and even military operations."
  },
  {
    date: 2016,
    tagline: "INNOVATION",
    copy: "Circadence unveils <a href='/project-ares'>Project Ares</a>, an award-winning, gamified cyber security learning platform that helps students and professionals build and keep skills sharp against evolving cyber threats. The hands-on platform offers foundational, intermediate and advanced cyber learning content that was informed by the company's rich history in software, multi-player game development, and application optimization. Its patented cyber range-as-a-service technology delivers authentic virtual machine-based exercises so cyber preparation is as true-to-life as it gets."
  },
  {
    date: 2010,
    tagline: "DEVELOPMENT",
    copy: "Due to the rapidly increasing sophistication of cybersecurity threat and intrusion patterns, coupled with the Government’s focus on extending the nation’s cybersecurity apparatus, Circadence shifted its business development focus to next generation cybersecurity solutions. The company began development of its cyber range business to build, manage and maintain next generation cyber ranges for the cyber test and evaluation community."
  },
  {
    date: 2005,
    tagline: "GROWTH",
    copy: "Circadence opened a second office in Tupelo, Mississippi. The company’s revenues grew four-fold between 2005 and 2008, during which time Circadence developed its application optimization technology under the name Circadence MVO™. From frontline war fighters to enterprise data centers, MVO has been evaluated, approved and implemented to support mission-critical communications for the U.S. Department of Defense, the U.S. Joint Forces Command, the U.S. Department of Homeland Security, the U.S. Army, the U.S. Marine Corps, and the U.S. Naval Research Laboratory. Additional customers include the U.S. government, state and local law enforcement, first responders, users dependent on satellite transmissions, enterprises with remote offices, rural and urban health facilities, and research institutions that need to ensure continuity of operations. Partnerships with companies such as Northrop Grumman and Lockheed Martin supported cutting-edge, network security operations."
  },
  {
    date: 2000,
    tagline: "REBRANDED",
    copy: "The company rebranded as Circadence and shifted its focus on software that could speed up application performance. Circadence sold the VR-1 entertainment division to Pacific Century CyberWorks Japan Co. in February 2001."
  },
  {
    date: 1995,
    tagline: "FOUNDED",
    copy: "Under the name VR-1, the company produced and released online videogames for clients including AOL’s Game Channel and Deutsche Telekom. The company was headquartered in Boulder, Colorado and the team continue to call it home. It was one of the first to develop massive multi-player games, releasing titles including “Air Attack” and “SARAC.” They first entered the national market with this slate of games in 1996 and 1997."
  }
]

function createMarkup(string) {
  return {__html: string}
}

class About extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      aboutVideo: "https://player.vimeo.com/video/323209493",
      videoLightbox: false,
      timelineReversed: false,
    };
  }

  toggleLightbox = () => {
    this.setState({
      videoLightbox: !this.state.videoLightbox
    })
  }

  render () {
    return (
      <Layout>
        <SEO title="About"/>
        <div className="fullscreen-video">
          <div className="video-content-wrapper">
            <div className="video-header-content">
              <h1>Helping Cyber Professionals Prepare and Protect</h1>
              <h3>Next Generation Solutions for the Cyber Security Workforce</h3>
              <button className="flat-button" onClick={this.toggleLightbox}>Learn more about Circadence</button>
            </div>
          </div>
          <video loop muted poster={thumbnail} autoPlay="autoplay" className="bg-video">
            <source src={aboutVideo}/>
          </video>
        </div>
        <div className="mainContainer" style={{background: "var(--gray-accent)", padding: "60px 0"}}>
          <div className="centeredContainer" style={{padding: "0 30px"}}>
            <p className="left-border">Powered by a culture of innovation and the demands of an evolving cyber landscape, Circadence offers <strong>cyber range solutions</strong> and cyber security learning platforms that leverage <strong>cyber-range-as-a-service technology</strong> and custom training content to address critical cyber challenges for enterprise, government, and academic institutions. <strong>Our unique approach to cyber security learning stems from the power of gamification and active-learning models.</strong></p>
          </div>
        </div>
        <div className="mainContainer">
          <div className="timeline-wrapper wrap">
            <h2>Our History</h2>
            <div className="timeline">
            {
              dates.map((date, index) => {

                let side = (index % 2 === 0 ? "t-left" : "t-right" )

                return (
                  <div className={`t-container ${side}`}>
                   <div className="t-content">
                     <h3 className="date-label">{date.date} <span style={{fontWeight: 200, fontSize: 20, float: "right"}}>{date.tagline}</span></h3>
                     <p dangerouslySetInnerHTML={createMarkup(date.copy)}></p>
                   </div>
                  </div>
                )
              })
            }
            </div>
          </div>
        </div>
        <VideoLightbox visible={this.state.videoLightbox} close={this.toggleLightbox} videoURL={this.state.aboutVideo}/>
      </Layout>
    )
  }

}

export default About;
